import { ProjectActions } from "../../reducers/project/actionsNames";
import { Category, IAttributes } from "../../reducers/project";

export default (id: string) => ({
  type: ProjectActions.DeleteCart,
  id,
});
